import { render, staticRenderFns } from "./StudentViewUserInfoCard.vue?vue&type=template&id=527ecdb0&"
import script from "./StudentViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./StudentViewUserInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports